export const ROOT = "/";

//export const ROOT = "http://localhost/pblog/";

export const apiROOT = ROOT + "api/"; 
